// protocolCache.js
import { createStore, get, set, del, keys, clear } from "idb-keyval";

// Create a named store (like a DB table)
const protocolStore = createStore("offline-db", "protocols");

export const cacheProtocol = async (id, data) => {
  await set(id, data, protocolStore);
};

export const getCachedProtocol = async (id) => {
  return await get(id, protocolStore);
};

export const removeCachedProtocol = async (id) => {
  await del(id, protocolStore);
};

export const listCachedProtocolIds = async () => {
  return await keys(protocolStore);
};

export const clearAllProtocols = async () => {
  await clear(protocolStore);
};

const protocolsCache = {
  cacheProtocol,
  getCachedProtocol,
  removeCachedProtocol,
  listCachedProtocolIds,
  clearAllProtocols,
};

export default protocolsCache;

